import emoji from 'node-emoji';
import React, { useCallback, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { Alert } from 'react-native';
import TextInput from 'utils/packages/TextInput';
import { AppView } from 'design-system';
import Spacer from 'design-system/Spacer';
import StatusBar from 'design-system/StatusBar';
import { styles as textStyles } from 'design-system/Text';
import { rem } from 'design-system/values';
import { getCategories } from 'actions';
import { useAutoFocusInput } from 'hooks/useAutoFocusInput';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import { useAppDispatch } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import { KeyboardAvoidingContainerNew } from 'design-system/KeyboardAvoidingContainerNew';
import { KeyboardAvoidingButton } from 'design-system/KeyboardAvoidingButton';
import { isWeb } from '../../../constants';
const strings = {
    screenTitle: 'Add a reference',
    placeholder: 'Reference',
    next: 'Continue',
    errorTitle: 'Hold on :dizzy:',
    errorMessage: 'You must enter a reference',
};
const ChooseCounterpartNameScreen = ({ navigation, route }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    useLayoutEffect(() => {
        navigation.setOptions({
            title: strings.screenTitle,
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    const [value, setValue] = useState('');
    const textInputRef = useRef(null);
    const dispatch = useAppDispatch();
    useAutoFocusInput(textInputRef);
    const onSubmit = useCallback(async () => {
        if (value.length < 1) {
            Alert.alert(emoji.emojify(strings.errorTitle), strings.errorMessage);
            return;
        }
        dispatch(getCategories());
        textInputRef.current?.blur();
        navigation.navigateDeprecated('EditCategory', {
            ...route.params,
            isPickingCategory: true,
            customName: value,
        });
    }, [route.params, value]);
    const onChangeText = useCallback((text) => {
        setValue(text);
    }, []);
    useAutoFocusInput(textInputRef);
    const textInput = useMemo(() => (<TextInput ref={textInputRef} style={[isWeb ? styles.font16 : styles.font26, styles.textInput]} value={value} placeholder={strings.placeholder} placeholderTextColor={colors.text.placeholder} selectionColor={colors.text.selection} underlineColorAndroid="transparent" textAlign="center" autoCapitalize="words" onChangeText={onChangeText} onSubmitEditing={onSubmit} focusStyle={isWeb ? styles.textInputFocus : undefined}/>), [
        styles.font16,
        styles.font26,
        styles.textInput,
        styles.textInputFocus,
        value,
        colors.text.placeholder,
        colors.text.selection,
        onChangeText,
        onSubmit,
    ]);
    return (<AppView isInTab={isWeb} avoidHeader>
      <StatusBar barStyle="dark-content" animated/>
      <KeyboardAvoidingContainerNew flexContainer withButtonSpace>
        {isWeb ? <Spacer h={72}/> : <Spacer flex/>}
        {textInput}
        <Spacer flex/>
      </KeyboardAvoidingContainerNew>
      <KeyboardAvoidingButton brand title={strings.next} onPress={onSubmit} withFrame={false}/>
    </AppView>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        flex: 1,
    },
    buttonContainer: {
        paddingHorizontal: rem(16),
    },
    font26: {
        fontSize: rem(26),
        color: colors.text.primary,
        lineHeight: undefined,
    },
    font16: {
        fontSize: rem(16),
        color: colors.text.primary,
        lineHeight: undefined,
    },
    textInput: isWeb
        ? { paddingVertical: rem(16), color: colors.text.secondary }
        : {
            ...textStyles.TextThin_20,
            flex: 1,
        },
    textInputFocus: {
        color: colors.text.primary,
    },
}));
export default ChooseCounterpartNameScreen;
